import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

const BlocSousDomaine = () => {
  const { idDomaine } = useParams();
  const [formations, setFormations] = useState([]);
  const [domaine, setDomaine] = useState(null);
  const Url = process.env.REACT_APP_URL_DEV;

  const fetchData = () => {
    axios
      .get(`${Url}/api/formation/formations/domaine/${idDomaine}`)
      .then((res) => setFormations(res.data.data))
      .catch((err) => console.error(err));

    axios
      .get(`${Url}/api/domaine/${idDomaine}`)
      .then((res) => setDomaine(res.data.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchData();
  }, [idDomaine, Url]);

  return (
    <div
      className="blog-area1 pd-top-80 pd-bottom-90 go-top"
      style={{ padding: '50px' }}
    >
      {domaine && (
        <div>
          <h3 className="text-center text-yellow">Introduction</h3>
          <div
            style={{ textAlign: 'justify' }}
            dangerouslySetInnerHTML={{ __html: domaine.domaineDescription }}
          ></div>
        </div>
      )}
      <div className="row mt-5">
        {formations.map((f) => (
          <div
            className="col-md-6 col-lg-4 col-sm-12 mt-5"
            key={f.formationCode}
          >
            <div className="single-blog-inner">
              <div className="thumb">
                <img
                  src={`${Url}/images/${f.formationImage}`}
                  alt={f.formationNom}
                />
              </div>
              <div className="details">
                <h5 style={{ fontSize: '14px', height: '70px' }}>
                  {f.formationNom}
                </h5>
                <Link
                  className="read-more-text"
                  to={`/course-details/${f.formationCode}`}
                >
                  <h6>Fiche Formations</h6>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlocSousDomaine;
